import { render, staticRenderFns } from "./question-choice-item.vue?vue&type=template&id=76e0cbf2"
import script from "./question-choice-item.vue?vue&type=script&lang=js"
export * from "./question-choice-item.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports